import {forwardRef} from 'react'
import {ArrowStickLeft} from 'shared/ui/icons'
import styles from './styles.module.scss'

type SliderControlButtonsProps = {
  step: number
  count: number
}

export const SliderControlButtons = forwardRef<HTMLDivElement, SliderControlButtonsProps>(({
  step,
  count,
  ...rest
}, ref) => {
  let axiosX = 0

  const handleScrollBtn = (direction: 'left' | 'right') => {
    let newValue = direction === 'left' ? axiosX - step : axiosX + step
    if (newValue < 0) newValue = (count - 2) * step
    if (newValue >= (count - 1) * step) newValue = 0

    //TODO понять как работает forwardRef в TS
    // @ts-ignore
    ref.current?.scrollTo({
      left: newValue,
      behavior: 'smooth'
    })

    axiosX = newValue
  }

  return (
    <div className={styles.controlContainer} {...rest}>
      <button className={styles.btnControl} onClick={() => handleScrollBtn('left')}>
        <div className={styles.arrowIcon}><ArrowStickLeft /></div>
      </button>
      <button className={styles.btnControl} onClick={() => handleScrollBtn('right')}>
        <div className={`${styles.arrowIcon} ${styles.rightArrow}`}><ArrowStickLeft /></div>
      </button>
    </div>
  )
})